import script from "./webComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./webComponent.vue?vue&type=script&setup=true&lang=js"

import "./webComponent.vue?vue&type=style&index=0&id=f137a2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.7.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f137a2f4"]])

export default __exports__